import { plainToInstance } from 'class-transformer'

import { GET_BANNER_DETAIL } from '@client/collections/Campaign/schemas/getBannerDetail'
import { GET_BOOKS_FROM_BANNER } from '@client/collections/Campaign/schemas/getBooksFromBanner'
import { gqlApiInstance } from '@client/init'
import { CampaignSearchFormType } from '@features/campaign/pages/CampaignPage/components/CampaignSearchForm/interface'
import { DisplayTypeEnum } from '@interfaces/DisplayTypeEnum'
import { CampaignResponse } from '@models/campaign/CampaignResponse'

export function useCampaignAction() {
  async function getBooksFromBanner(
    id: number,
    page: number,
    limitPerPage: number,
    searchParam: CampaignSearchFormType
  ): Promise<CampaignResponse> {
    const res = await gqlApiInstance.request(GET_BOOKS_FROM_BANNER, {
      page,
      limitPerPage,
      highlightBannerId: id,
      displayType: DisplayTypeEnum.WEB,
      bookType: searchParam.bookType || null,
      categoryIds: searchParam.categoryIds?.length
        ? searchParam.categoryIds.map((i: string) => Number(i))
        : null,
      penNameIds: searchParam.penNameIds?.length
        ? searchParam.penNameIds.map((i: string) => Number(i))
        : null,
      searchText: searchParam.searchText,
    })

    return plainToInstance(CampaignResponse, res.getBooksFromBanner)
  }

  async function getBannerDetail(id: number): Promise<string> {
    const { getHighlightBookBanner } = await gqlApiInstance.request(
      GET_BANNER_DETAIL,
      {
        getHighlightBookBannerId: id,
      }
    )

    return getHighlightBookBanner.bannerName
  }

  return {
    getBooksFromBanner,
    getBannerDetail,
  }
}
